﻿import { LiveDataSet, Status } from "../../API/LiveData/LiveDataSet";
import { IStationValueFormatter, IStationValueObject, WarningThreshold } from "../../Formatters/IStationValueFormatter";
import { ILiveDataListener, ILiveDataListenerContext } from "../../ILiveDataListener";
import { PopupChartable } from "../../PopupChartable";
import { ISiteObservationsPage } from "./ISiteObservationsPage";

export class ValueBox extends PopupChartable implements ILiveDataListener {
    private outerBox: JQuery;
    private innerBox: JQuery;
    private valueBox: JQuery;
    private unitsBox: JQuery;
    private suffixSpan: JQuery;
    private showTitle: boolean;

    constructor(
        page: ISiteObservationsPage,
        container: JQuery,
        valueFormatter: IStationValueFormatter,
        top: number,
        left: number,
        height: number,
        width: number,
        ctx: ILiveDataListenerContext,
        showTitle: boolean = true,
        valueTextSizeEm: number = 2.5,
        titleTextSizeEm?: number
    ){

        super(page.mainSite);

        this.valueFormatter = valueFormatter;
        this.station = page.station.Station;
        this.warningGroup = page.warningGroup;
        this.showTitle = showTitle;


        this.outerBox = $('<div></div>')
            .addClass('midi_SiteObservations_value_box_outer')
            .css('top', top + '%')
            .css('left', left + '%')
            .css('height', height + '%')
            .css('width', width + '%')
            .attr('title', 'Click for parameter popup')
            .click((e: JQueryMouseEventObject) => {
                this.renderPopup(e);
            });

        this.innerBox = $('<div></div>').addClass('midi_SiteObservations_value_box_inner').appendTo(this.outerBox);

        this.valueBox = $('<div></div>')
            .addClass('midi_SiteObservations_value_box_value')
            .css('font-size', valueTextSizeEm + 'em')
            .appendTo(this.innerBox);

        this.unitsBox = $('<div></div>').addClass('midi_SiteObservations_value_box_units').hide(); // start hidden, show if data
        if (showTitle) {
            this.unitsBox.text(this.valueFormatter.getUnits() ? this.valueFormatter.getUnits() : '');
        }

        this.suffixSpan = $('<span></span>').prependTo(this.unitsBox);

        if (showTitle) {
            let $title: JQuery = $('<div></div>')
                .addClass('midi_SiteObservations_value_box_header')
                .text(this.valueFormatter.getShortName())
                .append(this.unitsBox); // units box in header

            if (titleTextSizeEm) {
                $title.css('font-size', titleTextSizeEm + 'em');
            }

            this.outerBox.prepend($title);
        } else {
            this.innerBox
                .addClass('midi_SiteObservations_value_box_inner_no_header')
                .append(this.unitsBox); // units box in inner
        }

        container.append(this.outerBox);

        if (page.mainSite.liveDataManager.latestData) {
            this.liveDataChanged(page.mainSite.liveDataManager.latestData, ctx);
        }
    }

    public liveDataChanged(latestData: LiveDataSet, ctx: ILiveDataListenerContext): void {

        var valueObject: IStationValueObject = this.valueFormatter.format(
            latestData.Stations[this.station.Id],
            this.warningGroup
        );

        this.setSensor(this.valueFormatter.getSensorId() ?? valueObject.Sensor);
        this.setTimestamp(valueObject.Timestamp);
        this.outerBox.attr('title', 'Timestamp: ' + moment(moment.utc(valueObject.Timestamp)).tz(this.mainSite.selectedRegion.TimeZone).format("YYYY-MM-DD HH:mm") + '. Click for parameter popup.')

        ctx.valueChanged(valueObject);

        this.valueBox.text(valueObject.Value); // valueObject handles the formatting

        if (valueObject.ParameterDefinition && valueObject.ParameterDefinition.Suffix && this.showTitle) {
            this.suffixSpan.text(valueObject.ParameterDefinition.Suffix + ((this.valueFormatter.getUnits()) ? ', ' : ''));
        } else {
            this.suffixSpan.text('');
        }

        if (valueObject.Status === null || valueObject.Status === Status.Expired) {

            // no valid data -> hide units and remove any colour coding

            this.unitsBox.hide();

            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_3');

            this.innerBox.addClass('midi_siteObsPage_expiring');

            return;
        }

        if (valueObject.Status == Status.Good) {
            this.innerBox.removeClass('midi_siteObsPage_expiring');
        } else {
            this.innerBox.addClass('midi_siteObsPage_expiring');
        }

        // by this point we will be showing some data

        this.unitsBox.show();


        if (valueObject.WarningThreshold == WarningThreshold.Level3) {
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.innerBox.addClass('midi_siteObsPage_exceeded_threshold_3');
        } else if (valueObject.WarningThreshold == WarningThreshold.Level2) {
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_3');
            this.innerBox.addClass('midi_siteObsPage_exceeded_threshold_2');
        } else if (valueObject.WarningThreshold == WarningThreshold.Level1) {
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_3');
            this.innerBox.addClass('midi_siteObsPage_exceeded_threshold_1');
        } else {
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_3');
        }
    }
}